import { Button, IconMinusCircle, Wrapper } from '@screentone/core';

import { ConfirmationDialog } from 'components/confirmation-dialog/ConfirmationDialog';
import { ReadOnlyTooltip } from 'components/context-menu-actions/shared/ReadOnlyTooltip';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { useContextMenuActions } from 'contexts/context-menu-actions/useContextMenuActions';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { useDataModelContext } from 'contexts/datamodel/useDataModel';

import { getTotalContentItemCounts } from 'contexts/datamodel/DataModelContext.utils';

interface RemoveEntityProps {
  hierarchyId: string;
  text: string;
  confirmIfNotEmpty?: boolean;
  confirmHint?: string;
  disabled?: boolean;
}

export const RemoveEntity = ({
  hierarchyId,
  text,
  confirmIfNotEmpty = false,
  confirmHint,
  disabled = false
}: RemoveEntityProps) => {
  const { removeEntity, getEntity } = useDataModelContext();
  const { setActionModalComponent, setIsModalOpen } = useContextMenuActions();

  const showConfirmDialog = () => {
    setIsModalOpen(true);
    setActionModalComponent(
      <ConfirmationDialog
        title={text}
        description="Are you sure you want to remove this module?"
        hint={confirmHint}
        isLoading={false}
        showDialog={(show) => setIsModalOpen(show)}
        onClickFunc={() => {
          removeEntity(hierarchyId);
          setIsModalOpen(false);
        }}
      />
    );
  };

  const handleClick = () => {
    if (confirmIfNotEmpty) {
      const entity = getEntity(hierarchyId);
      const counts = entity ? getTotalContentItemCounts(entity) : null;
      if (counts && counts.totalCount > 0) {
        showConfirmDialog();
        return;
      }
    }
    removeEntity(hierarchyId);
  };

  return (
    <Wrapper>
      <ReadOnlyTooltip disabled={disabled}>
        <Button
          tertiary
          icon={IconMinusCircle}
          color="lava"
          data-testid="page-content-card-remove-button"
          onClick={handleClick}
          disabled={disabled}
        >
          {text}
        </Button>
      </ReadOnlyTooltip>
    </Wrapper>
  );
};
